import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions } from '../../../core/components/grid/grid.types';
import { DataTaskService } from '../../../core/services/data-task.service';
import { StateService } from '../../../core/services/state.service';

@Component({
  selector: 'tt-trace-search',
  templateUrl: './trace-search.component.html',
  styleUrls: ['./trace-search.component.css']
})
export class TraceSearchComponent implements OnInit {
    argType;

    argValue;

    public setting?: Setting;

    public grid?: GridOptions;

    public retrieving = false;

    constructor(private stateService: StateService, private datatask: DataTaskService) {
        this.argType = this.stateService.getStateParams()['argtype'];
        this.argValue = this.stateService.getStateParams()['argvalue'];
    }

    private async loadSetting() {
        if (!!this.argType && !!this.argValue) {
            this.setting = (await this.datatask.Post(2453, {
                argtype: this.argType,
                argvalue: this.argValue
            }))[0];
        }
    }

    private loadGrid() {
        if (!this.setting) return;

        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId(this.setting.view_id)
                .setLoadDataFunction({
                    method: this.setting.p2_datatask_keyno,
                    parameters: () => this.setting
                })
                .setKendoConfig({ height: '100%' })
                .setToolbar({ wrapping: true });
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    public async retrieveChanges() {
        if (!!this.setting) {
            this.retrieving = true;

            this.grid?.gridfunc?.read().then(() => this.retrieving = false);
        }
    }

    private async init() {
        await this.loadSetting();
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    stockbatch_keyno: string;
    suppliers_batchno: string;
    purch_order_no: string;
    invoice_no: string;
    argtype: string;
    argvalue: string;
    p2_datatask_keyno: number;
    view_id: string;
}
